import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'containers.CustomerTeamPage.Teams.manageBranches',
    defaultMessage: 'Manage your teams',
  },
  subtitle: {
    id: 'containers.CustomerTeamPage.Teams.manageBranches.subtitle',
    defaultMessage: 'Add existings contacts to a team, or invite new contacts to join.',
  },
  invite: {
    id: 'containers.CustomerTeamPage.Teams.invite',
    defaultMessage: 'Invite',
  },
  branches: {
    id: 'containers.CustomerTeamPage.Teams.branches',
    defaultMessage: 'Teams',
  },
  contacts: {
    id: 'containers.CustomerTeamPage.Teams.contacts',
    defaultMessage: 'Producers',
  },
})
